import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BYPASS_INTERCEPTOR } from '@connect-services/client/interceptors/http-errors.interceptor';
import { License } from '@connect-services/client/sdk/api';

export function httpApplicationNameInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const requestHeader = request.clone({
        headers: request.headers.set('application-name', License.ApplicationEnum.CONNECT_SERVICES),
    });

    if (
        request.context.has(BYPASS_INTERCEPTOR) &&
        request.context.get(BYPASS_INTERCEPTOR).includes('httpApplicationNameInterceptor')
    ) {
        return next(request);
    }

    return next(requestHeader);
}
